import '.cx{border-radius:24px;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.bv{display:none;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.dz{top:50%;}.ssr-plugin'
import '.e0{transform:translateY(-50%);}.ssr-plugin'
import '.e1{right:0px;}.ssr-plugin'
import '.e2{left:0px;}.ssr-plugin'
import '.e3{height:72px;}.ssr-plugin'
import '.e4{width:72px;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.ab{border-radius:50%;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import '.e5{border:none;}.ssr-plugin'
import '.e6{bottom:24px;}.ssr-plugin'
import '.ag{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.e7{padding:16px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.k{height:100%;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.e8{transition:transform 600ms cubic-bezier(0.25, 1, 0.35, 1);}.ssr-plugin'
import { styled } from 'inlines'
import { useEffect, useRef, useState } from 'react'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { Video } from 'excelsis-video'
import { colors } from '../utils/colors.js'
import { Stepper } from './Stepper.js'
import { LastSlide } from './LastSlide.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { Button } from './Button.js'
import { StepperVideo } from './StepperVideo.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { parseContestantImageSrc } from '../utils/parseImageSrc.js'

const WIDTH = '40vw'
const HALF_WIDTH = 20
const HEIGHT = '100dvh'

const TABLET_WIDTH = '72vw'
const TABLET_HALF_WIDTH = 36

type Slide = {
  src: string
  poster?: string
}

type VideoSlideProps = {
  slide: Slide
  idx: number
  index: number
  goToIndex: (n: number) => void
  sliderRef: React.RefObject<HTMLDivElement | null>
  arr: Slide[]
  dictionary: Record<string, string>
}

const VideoSlide = ({
  slide,
  idx,
  index,
  goToIndex,
  sliderRef,
  arr,
  dictionary,
}: VideoSlideProps) => {
  const [showPauseButton, setShowPauseButton] = useState(false)
  const [showPlayButton, setShowPlayButton] = useState(true)
  const [isPortrait, setIsPortrait] = useState(true)

  return (
    <styled.div className="cx c2 e w"
      key={slide.src}
      style={{
        height: index === idx ? '100%' : '60%',
        width: index === idx ? WIDTH : `${HALF_WIDTH}vw`,
        [TABLET]: {
          width: index === idx ? TABLET_WIDTH : `${TABLET_HALF_WIDTH}vw`,
        },
        [MOBILE]: {
          width: '100vw',
          borderRadius: '0px',
        },
      }}
      onClick={() => {
        if (idx !== index) {
          goToIndex(idx)
          const videos = sliderRef.current?.querySelectorAll('video')
          for (const v of videos ?? []) {
            v.pause()
          }
        }
      }}
    >
      <Video
        // @ts-ignore
        playsInline
        // @ts-ignore
        preload={idx === index ? 'metadata' : 'none'}
        // @ts-ignore
        onPause={() => {
          setShowPauseButton(false)
          setShowPlayButton(true)
        }}
        onPlay={() => {
          const videos = sliderRef.current?.querySelectorAll('video')
          if (index === arr.length) {
            for (const v of videos ?? []) {
              v.pause()
            }
            return
          }
          setShowPauseButton(false)
          setShowPlayButton(false)
          for (const [i, v] of videos?.entries() ?? []) {
            if (i !== idx && !v.paused) {
              v.pause()
            }
          }
        }}
        onMouseEnter={() => !showPlayButton && setShowPauseButton(true)}
        onMouseLeave={() => setShowPauseButton(false)}
        //  autoPlay={idx === index}
        onEnded={() => {
          const videos = sliderRef.current?.querySelectorAll('video')
          for (const v of videos ?? []) {
            v.pause()
          }
          goToIndex(index + 1)
        }}
        onLoadedMetadata={(e) => {
          const v = e.currentTarget as HTMLVideoElement
          setIsPortrait(v.videoHeight >= v.videoWidth)
        }}
        src={slide.src}
        poster={parseContestantImageSrc(slide?.poster as string, 256)}
        style={{
          aspectRatio: '9/16',
          maxHeight: '100vh',
          border: 'none',
          borderRadius: 24,
          boxSizing: 'border-box',
          position: 'relative',
          scale: 0.76,
          opacity: index !== idx ? 0.5 : 1,
          '& img': {
            borderRadius: '16px',
          },
          '& video': {
            borderRadius: '24px',
            border: `1px solid ${colors.border}`,
            objectFit: isPortrait ? 'cover' : 'contain',
            backgroundColor: colors.secondary,
          },
          [MOBILE]: {
            height: '100vh',
            scale: 1,
            '& img': {
              borderRadius: '0px',
            },
            '& video': {
              borderRadius: '0px',
              scale: 1.24,
              backgroundColor: colors.secondary,
            },
          },
        }}
      >
        <styled.div className="bv"
          style={{
            [MOBILE]: {
              display: 'block',
              height: '142px',
              position: 'absolute',
              width: '100%',
              bottom: 0,
              left: 0,
              right: 0,
              background: `linear-gradient(0deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
              zIndex: 0,
            },
          }}
        />
        <styled.div className="bv"
          style={{
            [MOBILE]: {
              display: 'block',
              height: '142px',
              position: 'absolute',
              width: '100%',
              top: 0,
              left: 0,
              right: 0,
              background: `linear-gradient(180deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
              zIndex: 0,
            },
          }}
        />
        {idx === index && (
          <Video.SoundButton
            style={{
              position: 'absolute',
              top: 24,
              right: 24,
              width: 32,
              height: 32,
              borderRadius: 16,
              background:
                'linear-gradient(0deg, var(--White, rgba(255, 255, 255, 0.25)) 0%, var(--White, rgba(255, 255, 255, 0.25)) 100%)',
              [MOBILE]: {
                top: '72px',
              },
            }}
            soundOffIcon={<Icon type="volumeOffIcon" />}
            soundOnIcon={<Icon type="volumeIcon" />}
          />
        )}
        {idx !== 0 && (
          <IconButton
            style={{
              position: 'absolute',
              display: 'none',
              top: 24,
              left: 24,
              width: 32,
              height: 32,
              borderRadius: 16,
              background:
                'linear-gradient(0deg, var(--White, rgba(255, 255, 255, 0.25)) 0%, var(--White, rgba(255, 255, 255, 0.25)) 100%)',
              [MOBILE]: {
                top: '52px',
                display: 'flex',
                zIndex: 1,
              },
            }}
            icon={<Icon type="backIcon" />}
            onClick={() => {
              if (index !== 0) {
                goToIndex(index - 1)
                const videos = sliderRef.current?.querySelectorAll('video')
                for (const v of videos ?? []) {
                  v.pause()
                }
              }
            }}
          />
        )}
        {showPlayButton && idx === index && (
          <styled.button className="a6 dz e0 e1 e2 e3 e4 e w cy ap ab ar e5"
            style={{
              background: colors.white,
              '&svg': { width: '90px' },
            }}
          >
            <Icon
              type="playIcon"
              color={colors.black}
              style={{ width: 34, height: 34 }}
            />
          </styled.button>
        )}
        {showPauseButton && idx === index && (
          <button className="a6 dz e0 e1 e2 ap e3 e4 ab e5 e w cy ar"
            style={{
              backgroundColor: colors.white,}}
          >
            <Icon
              type="pauseIcon"
              color={colors.black}
              style={{ width: 34, height: 34 }}
            />
          </button>
        )}
        <Video.Loader />
        {index === idx && (
          <Video.TimeLine
            style={{
              position: 'absolute',
              bottom: 24,
              left: 24,
              right: 24,
              width: 'calc(100% - 48px)',
              [MOBILE]: { display: 'none' },
            }}
          />
        )}
        {index === idx && (
          <styled.div className="a6 e6 ag be e7 bv"
            style={{
              [MOBILE]: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              },
            }}
          >
            <styled.h3>{dictionary?.thankYouForVoting}</styled.h3>
            <Button
              id="thanks-page-action-next-slide-button"
              variant="border"
              trailIcon={<Icon type="forwardIcon" />}
              onClick={() => {
                goToIndex(index + 1)
              }}
            >
              {dictionary?.nextButton}
            </Button>
          </styled.div>
        )}
      </Video>
    </styled.div>
  )
}

export const Slider = ({ arr, phoneContestant }) => {
  const [index, setIndex] = useState(0)
  const [progress, setProgress] = useState(0)
  const sliderRef = useRef<HTMLDivElement>(null)
  const [lang] = useLanguage()

  const dictionary = useDictionary()

  const goToIndex = (newIndex: number) => {
    const videos = sliderRef.current?.querySelectorAll('video')
    for (const [idx, v] of videos?.entries() ?? []) {
      v.currentTime = 0
      if (idx === newIndex) {
        v.play()
      } else {
        v.pause()
      }
    }
    setProgress(0)
    setIndex(newIndex)
  }

  useEffect(() => {
    const videos = sliderRef.current?.querySelectorAll('video')
    const current = videos?.[index]
    if (!current) return
    const onTimeUpdate = () => {
      if (current.duration > 0) {
        setProgress((current.currentTime / current.duration) * 100)
      }
    }
    current.addEventListener('timeupdate', onTimeUpdate)
    return () => current.removeEventListener('timeupdate', onTimeUpdate)
  }, [index])

  return (
    <>
      <Stepper
        steps={arr.length + 1}
        currentStep={index + 1}
        style={{
          width: 96,
          position: 'absolute',
          right: 24,
          top: 36,
          zIndex: 1,
          [MOBILE]: {
            display: 'none',
          },
        }}
      />
      <StepperVideo
        steps={arr.length + 1}
        currentStep={index}
        currentStepProgresss={progress}
        style={{
          display: 'none',
          position: 'absolute',
          zIndex: 1,
          [MOBILE]: {
            display: 'flex',
            left: '24px',
            right: '24px',
            top: '24px',
            width: 'calc(100% - 48px)',
          },
        }}
      />
      <styled.div className="ai ap m e w"
        style={{
          maxWidth: WIDTH,
          height: HEIGHT,
          [TABLET]: {
            maxWidth: TABLET_WIDTH,
          },
          [MOBILE]: {
            maxWidth: '100vw',
          },
        }}
      >
        {/* Navigation system */}
        <styled.div className="e ao w a6 k m"
          style={{
            [MOBILE]: {
              display: 'none',
            },
          }}
        >
          <IconButton
            style={{
              zIndex: 1,
              cursor: index === 0 ? 'auto' : 'pointer',
              opacity: index === 0 ? 0 : 1,
              '&:hover': {
                opacity: index === 0 ? 0 : 1,
              },
            }}
            icon={<Icon type="backIcon" />}
            onClick={() => {
              if (index !== 0) {
                goToIndex(index - 1)
              }
            }}
          />
          <IconButton
            id="thanks-page-action-next-slide-arrow-button"
            style={{
              zIndex: 1,
              display: index === arr.length ? 'none' : 'flex',
            }}
            icon={<Icon type="forwardIcon" />}
            onClick={() => {
              if (index < arr.length) {
                goToIndex(index + 1)
              }
            }}
          />
        </styled.div>

        {/* Slider wrapper*/}
        <styled.div className="e a6 w cf e8"
          ref={sliderRef}
          style={{
            height: HEIGHT,
            left: lang.rtl ? 'auto' : '0px',
            right: lang.rtl ? '0px' : 'auto',
            transform: `translateX(${lang.rtl ? index * HALF_WIDTH : -index * HALF_WIDTH}vw)`,
            [TABLET]: {
              transform: `translateX(${lang.rtl ? index * TABLET_HALF_WIDTH : -index * TABLET_HALF_WIDTH}vw)`,
            },
          }}
        >
          {/* Slide */}
          {arr?.map((slide, idx) => (
            <VideoSlide
              key={slide.src}
              slide={slide}
              idx={idx}
              index={index}
              goToIndex={goToIndex}
              sliderRef={sliderRef}
              arr={arr}
              dictionary={dictionary as any}
            />
          ))}
          <LastSlide
            index={index}
            goToIndex={goToIndex}
            dictionary={dictionary}
            phoneContestant={phoneContestant}
            style={{
              width:
                phoneContestant && index !== arr.length
                  ? '30vw'
                  : index === arr.length
                    ? `calc(${WIDTH} - 160px)`
                    : `${HALF_WIDTH}vw`,
              aspectRatio: '1/1',
              maxHeight: '100vh',
              margin: index === arr.length ? '96px 80px' : '0',
              opacity: index === arr.length ? 1 : 0.5,
              transform:
                phoneContestant && index !== arr.length
                  ? 'scale(0.54)'
                  : index === arr.length
                    ? 'none'
                    : 'scale(0.76)',
              transformOrigin: 'center',
              [TABLET]: {
                width:
                  index === arr.length
                    ? `calc(${TABLET_WIDTH} - 160px)`
                    : `${TABLET_HALF_WIDTH}vw`,
              },
              [MOBILE]: {
                display: index === arr.length ? 'flex' : 'none',
                padding: '72px 24px 24px',
                boxSizing: 'border-box',
                margin: '0px',
                backgroundColor: 'transparent !important',
                width: '100vw',
                height: '100svh',
                justifyContent: 'flex-start',
                border: 'none',
                gap: 0,
              },
            }}
          />
        </styled.div>
      </styled.div>
    </>
  )
}
